export const permissions = {
  DASHBOARD: "DASHBOARD",
  COMPANY_MANAGEMENT: "COMPANY_MANAGEMENT",
  DEPARTMENTS: "DEPARTMENTS",
  USER_MANAGEMENT: "USER_MANAGEMENT",
  STOCK_MANAGEMENT: "STOCK_MANAGEMENT",
  STOCK_DOCUMENT_CREATOR: "STOCK_DOCUMENT_CREATOR",
  INVOICING: "INVOICING",
  ROLES_PERMISSIONS: "ROLES_PERMISSIONS",
  UNIT_MANAGEMENT: "UNIT_MANAGEMENT",
  IMPORT: "IMPORT",
  CONFIGURATOR: "CONFIGURATOR",
  WORKS: "WORKS",
  PARCELS: "PARCELS",
  PARCEL_MANAGEMENT: "PARCEL_MANAGEMENT",
  PERSONS: "PERSONS",
  WORK_MACHINES: "WORK_MACHINES",
  WORK_APPROVAL: "WORK_APPROVAL",
  WORK_INTERVAL_UNIT_PRICES: "WORK_INTERVAL_UNIT_PRICES",
  CULTURES: "CULTURES",
  SC_BONUS: "SC_BONUS",
  SC_HOLIDAY: "SC_HOLIDAY",
  SC_EMPLOYEE: "SC_EMPLOYEE",
  SC_EMPLOYEE_ROLE: "SC_EMPLOYEE_ROLE",
  SC_MEASURE_UNIT: "SC_MEASURE_UNIT",
  SC_SHIFT: "SC_SHIFT",
  SC_WORK: "SC_WORK",
  SC_WORK_GROUP: "SC_WORK_GROUP",
  SC_WORK_LOG: "SC_WORK_LOG",
  SC_REPORTS: "SC_REPORTS",
  SEASONS: "SEASONS",
  CF_IMPORT_CONFIG: "CF_IMPORT_CONFIG",
  VALIDATED_DATA_SPECIAL_CASES: "VALIDATED_DATA_SPECIAL_CASES",
  SETTINGS: "SETTINGS",
  STATUSES: "STATUSES",
  TRACTOR_IMPORT: "TRACTOR IMPORT",
  SHAPE_IMPORT: "SHAPE_IMPORT",
  FACE_CAM_EMAIL_IMPORT: "FACE_CAM_EMAIL_IMPORT",
  SALARY_CALCULATOR_IMPORT :"SALARY_CALCULATOR_IMPORT",
  SALARY_CALCULATOR_HECTARE_IMPORT :"SALARY_CALCULATOR_HECTARE_IMPORT",
  DATA_IMPORT: "DATA_IMPORT",
  WORK_TYPE_IMPORT: "WORK_TYPE_IMPORT",
  LEASE_CONTRACT: "LEASE_CONTRACT",
  SM_PARTNERS: "SM_PARTNERS",
  SM_PRODUCTS: "SM_PRODUCTS",
  SM_PRODUCT_INTERVAL_UNIT_PRICES: "SM_PRODUCT_INTERVAL_UNIT_PRICES",
  SM_MOVEMENTS: "SM_MOVEMENTS",
  SM_STOCK: "SM_STOCK",
  SM_WAREHOUSES: "SM_WAREHOUSES",
  SM_TRANSACTIONS: "SM_TRANSACTIONS",
  STOCK_PARTNER_IMPORT: "STOCK_PARTNER_IMPORT",
  STOCK_PRODUCT_IMPORT: "STOCK_PRODUCT_IMPORT",
  STOCK_INITIAL_IMPORT: "STOCK_INITIAL_IMPORT",
  JUSTIFYING_DOCUMENTS: "JUSTIFYING_DOCUMENTS",
  DIGITAL_AGENDA: "DIGITAL_AGENDA",
  DIGITAL_MAPS: "DIGITAL_MAPS",
  ARENDA: "ARENDA",
  SCOUTINGS: "SCOUTINGS",
  SGPS_DASC_IMPORT: "SGPS_DASC_IMPORT",
  PARCEL_CULTURE_IMPORT: "PARCEL_CULTURE_IMPORT",
  REPORT_ADMIN: "REPORT_ADMIN",
  REPORTS: "REPORTS",
  REPORT_GROUPS: "REPORT_GROUPS",
  ARENDA_CONTRACTS_ADMIN: "ARENDA_CONTRACTS_ADMIN",
  ARENDA_PRODUCTS_ADMIN: "ARENDA_PRODUCTS_ADMIN",
  ARENDA_PRICES_ADMIN: "ARENDA_PRICES_ADMIN",
  ARENDA_TARIF_ADMIN: "ARENDA_TARIF_ADMIN",
  SCALES: "SCALES",
  SCALE_HOUSES: "SCALE_HOUSES",
  PRODUCT_CATALOG: "PRODUCT_CATALOG",
  MANAGEMENT_BOARD: "MANAGEMENT_BOARD",
  WORK_LIST: "WORK_LIST",
  WEIGHING_ON_SCALE: "WEIGHING_ON_SCALE",
  QUANTITY_WARNINGS: "QUANTITY_WARNINGS",
  FIELD_REPORT: "FIELD_REPORT",
  SM_INVOICE_MANAGEMENT: "SM_INVOICE_MANAGEMENT",
  SM_PREDEFINED_LOT_NUMBER: "SM_PREDEFINED_LOT_NUMBER",
  SM_STORAGE_LOSSES: "SM_STORAGE_LOSSES",
  SM_CONTRACTS_PURCHASE_SALE: "SM_CONTRACTS_PURCHASE_SALE",
  SM_ORDERS: "SM_ORDERS",
  WORK_GROUPS: "WORK_GROUPS",
  APIA: "APIA",
  ACCESS_ACTIVITY_LOGS: "ACCESS_ACTIVITY_LOGS",
  USER_ANALYTICS: "USER_ANALYTICS",
  LABEL_MANAGEMENT: "LABEL_MANAGEMENT",
  ERP_INTEGRATION: "ERP_INTEGRATION",
  AI_CHAT: "AI_CHAT",
};

export const permissionTypes = {
  module: 'module',
  access: 'access'
}

export const actions = {
  r: 'r',
  w: 'w',
  x: 'x',
  R: 'r',
  W: 'w',
  X: 'X',
  READ: 'r',
  UPDATE: 'w',
  EDIT: 'w',
  DELETE: 'x'
};

export const defaultActions = {
  access: {
    r: false,
    w: false,
    x: false,
  },
};

export function getPerm(perm, action) {
  return {
    type: perm,
    code: perm,
    action: action,
  }
}

//for grid items / actions edit-delete
export function hasPermission(object, user, type, action) {
  if (process.env.VUE_APP_DEBUG_PERMISSIONS === true) {
    console.log('has perm? ', object, 'user', user, 'type', type, 'action', action);
  }

  //object needs department_uuid, usually comes from grid rows
  if(user && (Boolean(user.is_superadmin === 1) || Boolean(user.is_company_admin === 1))) {
    return true;
  }

  let permissson = getAccess(object, user, type, action);
  if(permissson && permissson.access) {
    switch(action) {
      case 'r':
        return permissson.access.r || permissson.access.w || permissson.access.x;
      case 'w':
        return permissson.access.w;
      case 'x':
        return permissson.access.x;
      default:
        return false;
    }
  } else {
    return false;
  }
}

//for menu modules
export function hasModuleAccess(user, module, context = {}) {
  if (context?.config?.need_super_admin === true && (Boolean(user?.is_superadmin !== 1))) {
    return false;
  }

  //console.log('hasModuleAccess. user: ', user, 'module', module);
  if (user && (Boolean(user?.is_superadmin === 1) || Boolean(user?.is_company_admin === 1))) {
    return true;
  }
  //console.log('checking permissions. hasModuleAccess: ', 'user roles', user.roles);

  return Object.assign([], user?.roles).filter((role) => {
    return role.permissions.find(
      p => p.code.toString().toUpperCase() === module.toString().toUpperCase()
    );
  }).length > 0;
}

export function getAccess(object, user, type, action) {
  if(user && user.uuid && type) {
    let roles = null;
    if(object && object.department_uuid) {
      // if have department_uuid, get only roles for that department
      roles = Object.assign([], user?.roles).filter(
        r => r?.department_uuid?.toString() === object?.department_uuid?.toString()
      );
    } else {
      // if no department_uuid, get all roles
      roles = Object.assign([], user?.roles);
    }

    if (roles && roles.length > 0) {
      // in roles array, find role with permission for type and action if has
      let founded_role = roles.find(r =>
        r.permissions.find(p =>
          p.code.toString().toUpperCase() === type.toString().toUpperCase() &&
          p.access && p.access[action] === true
        )
      );

      let perm = null; // the founded permission
      if (founded_role) {
        perm = founded_role.permissions.find(p => p.code.toString().toUpperCase() === type.toString().toUpperCase());
      }

      return perm ? perm : defaultActions;
    }
  }

  return defaultActions;
}

/* Check permission */

export function hasRole(context, pRole){
  return hasModuleAccess(context.$store.getters['auth/user'], pRole, context);
}

export function canView(context) {
  if (process.env.VUE_APP_DEBUG_PERMISSIONS === true) {
    console.log('can view?');
  }

  if(context.config && context.config.permission) {
    return hasModuleAccess(context.$store.getters['auth/user'], context.config.permission, context);
  }

  return true; //be able to edit, if permission is not set
}

export function canEdit(context) {
  if (process.env.VUE_APP_DEBUG_PERMISSIONS === true) {
    console.log('can edit?');
  }

  if(context.config && context.config.permission) {
    if (context.config.permission_type === permissionTypes.module) {
      return hasModuleAccess(context.$store.getters['auth/user'], context.config.permission, context);
    } else {
      return hasPermission(context.data, context.$store.getters['auth/user'], context.config.permission, actions.EDIT);
    }
  }

  return true; //be able to edit, if permission is not set
}

export function canDelete(context) {
  if (process.env.VUE_APP_DEBUG_PERMISSIONS === true) {
    console.log('can delete?');
  }
  if(context.config && context.config.permission) {
    if (context.config.permission_type === permissionTypes.module) {
      return hasModuleAccess(context.$store.getters['auth/user'], context.config.permission, context);
    } else {
      return hasPermission(context.data, context.$store.getters['auth/user'], context.config.permission, actions.DELETE);
    }
  }

  return true; //be able to delete if permission is not set
}
